import type { ReactNode } from 'react';

import { Flex, Text } from '@bonusly/design-system';

interface BizyInputBannerProps {
	/** The message shown on the left of the banner. */
	message: ReactNode;
	/** Optional action rendered on the right (link, button, etc.). */
	action?: ReactNode;
	/** Optional icon rendered before the message. */
	icon?: ReactNode;
}

export function BizyInputBanner({ message, action, icon }: BizyInputBannerProps) {
	return (
		<Flex
			role="note"
			align="center"
			justify="space-between"
			gap={1}
			px={3}
			pt={3}
			pb={5}
			mb={-3}
			bg="bg.minipage"
			border="1px solid"
			borderColor="border.onOverlay"
			borderRadius="lg"
			borderBottomRadius="none"
			position="relative"
		>
			<Flex align="center" gap={2} minW={0}>
				{icon}
				<Text fontSize="sm" sx={{ textWrap: 'pretty' }} color="text.softest" noOfLines={2}>
					{message}
				</Text>
			</Flex>
			{action ? <Flex flexShrink={0}>{action}</Flex> : null}
		</Flex>
	);
}
